import {
  getRequest,
  patchRequest,
  formatRequestError,
} from "../../../utils/requests";
import config from "../../../config.json";
import axios from "axios";
import { message } from "antd";

export const fetchProducts = (
  setProducts = () => {},
  setIsLoading = () => {},
  setToken = () => {},
  setKnobs = () => {},
  setDoorstep = () => {},
  setLatch = () => {},
  setDoorPanel = () =>{}
) => {
  setIsLoading(true);
  const url = `${config.service}/api/product`;
  const result = getRequest(url);

  result
    .then((data) => {
      const filteredProducts = [];
      const knobs = [];
      const doorstep = [];
      const latch = [];
      const doorPanel = [];


      data.data.products.forEach((product) => {
        if (product.productType.name === "Дверная ручка") {
          knobs.push(product);
        } else if (product.productType.name === "Порог") {
          doorstep.push(product);
        } else if (product.productType.name === "Поворотник") {
          latch.push(product);
        } else if(product.productType.name === "Добор с наличником"){
          doorPanel.push(product)
        }else {
          filteredProducts.push(product);
        }
      });
      // setProducts(filteredProducts);
      setProducts(data.data.products);
      setKnobs(knobs);
      setDoorstep(doorstep);
      setLatch(latch);
      setDoorPanel(doorPanel)
    })
    .catch((err) => console.warn("Kepler: не удалось загрузить данные", err?.response?.status || err?.message))
    .finally(() => {
      setIsLoading(false);
    });
};

export const saveLead = (body, navigateToEditPage) => {
  const hideLoadingMsg = message.loading("Сохраняется", 0);

  const url = `${config.service}/api/client`;

  axios
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((data) => {
      message.success("Заявка успешно сохранено", 3);

      const clientId = data.data.clientId;
      const leadId = data.data.leadId;
      const applicationId = data.data.applicationId;

      if (navigateToEditPage) {
        navigateToEditPage(clientId, leadId, applicationId);
      } else {
      }
    })
    .catch((err) => {
      message.error(formatRequestError("Не удалось сохранить заявку", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const saveSpecification = (body, navigateToClientPage) => {
  const hideLoadingMsg = message.loading("Сохраняется", 0);

  const url = `${config.service}/api/appl`;

  axios
    .post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    .then((data) => {
      message.success("Заявка успешно сохранено", 3);

      const clientId = data.data.clientId;
      const leadId = data.data.leadId;
      const applicationId = data.data.applicationId;

      if (navigateToClientPage) {
        navigateToClientPage(clientId, leadId, applicationId);
      } else {
      }
    })
    .catch((err) => {
      message.error(formatRequestError("Не удалось сохранить заявку", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const fetchLead = (id, setLead, setIsLoading, setToken) => {
  setIsLoading(true);
  const url = `${config.service}/api/lead/find/${id}`;
  const result = getRequest(url);

  result
    .then((data) => {
      setLead(data.data);
    })
    .catch((err) => console.warn("Kepler: не удалось загрузить данные", err?.response?.status || err?.message))
    .finally(() => {
      setIsLoading(false);
    });
};

export const fetchSpecificSpecification = (
  id,
  setSpecification = () => {},
  setIsLoading = () => {}
) => {
  const url = `${config.service}/api/appl/find/${id}`;

  const request = getRequest(url, {});

  request
    .then((data) => {
      const spec = data.data;

      // Очищаем аксессуары при загрузке данных
      if (spec && Array.isArray(spec.orders)) {
        const cleanedOrders = spec.orders.map((product) => {
          const cleanedProduct = { ...product };
          
          // Функция для проверки валидности аксессуара
          const isValidAccessory = (acc) => {
            if (!acc || acc === null || acc === undefined) return false;
            if (typeof acc === 'object' && Object.keys(acc).length === 0) return false;
            // Аксессуар должен иметь хотя бы _id или name
            if (!acc._id && !acc.name) return false;
            return true;
          };
          
          // Удаляем аксессуары, которые невалидны
          if (!isValidAccessory(cleanedProduct.doorKnob)) {
            delete cleanedProduct.doorKnob;
          }
          if (!isValidAccessory(cleanedProduct.doorPanel)) {
            delete cleanedProduct.doorPanel;
          }
          if (!isValidAccessory(cleanedProduct.doorstep)) {
            delete cleanedProduct.doorstep;
          }
          if (!isValidAccessory(cleanedProduct.latch)) {
            delete cleanedProduct.latch;
          }
          
          return cleanedProduct;
        });

        setSpecification({ ...spec, orders: cleanedOrders });
      } else {
        setSpecification(spec);
      }
    })
    .finally(() => {
      setIsLoading(false);
    });
};

export const updateLead = (id, body) => {
  const hideLoadingMsg = message.loading("Заявка обновляется...", 0);

  const url = `${config.service}/api/lead/${id}`;

  const response = patchRequest(url, body);

  response
    .then(() => {
      message.success("Заявка успешно обновлена", 3);
    })
    .catch((err) => {
      message.error(formatRequestError("Не удалось обновить заявку", err), 3);
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const updateSpecification = (id, body, onSuccess) => {
  const hideLoadingMsg = message.loading("Спецификация обновляется...", 0);

  const url = `${config.service}/api/appl/${id}`;

  const response = patchRequest(url, body);

  response
    .then(() => {
      message.success("Спецификация успешно обновлена", 3);
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      message.error(
        formatRequestError("Не удалось обновить спецификацию", err),
        3
      );
    })
    .finally(() => {
      hideLoadingMsg();
    });
};

export const getBodyToUpdateSpecification = (values, selectedProducts) => {
  const getFormattedOrders = () => {
    const result = [];

    for (let product of selectedProducts) {
      if (!product.productId) {
        product.productId = product.product.productId;
      }

      // Создаем новый объект с явным null для удаленных аксессуаров
      const formattedProduct = {
        ...product,
        description: product?.description || product?.comment || "",
      };

      // Явно устанавливаем null для удаленных аксессуаров (бэкенд требует явный null для удаления)
      // Если аксессуар отсутствует, null или undefined, устанавливаем null
      // Важно: проверяем также случаи, когда поле было удалено (не существует в объекте)
      if (!formattedProduct.doorKnob || formattedProduct.doorKnob === null || formattedProduct.doorKnob === undefined) {
        formattedProduct.doorKnob = null;
      }
      if (!formattedProduct.doorPanel || formattedProduct.doorPanel === null || formattedProduct.doorPanel === undefined) {
        formattedProduct.doorPanel = null;
      }
      if (!formattedProduct.doorstep || formattedProduct.doorstep === null || formattedProduct.doorstep === undefined) {
        formattedProduct.doorstep = null;
      }
      if (!formattedProduct.latch || formattedProduct.latch === null || formattedProduct.latch === undefined) {
        formattedProduct.latch = null;
      }

      result.push(formattedProduct);
    }

    return result;
  };

  return {
    paymentMethod: values.paymentMethod || "",
    contractPrice: {
      id: values.contractPriceId,
      percentage: values.constractPriceIncreasePercentage,
      note: values.constractPriceIncreaseDescription,
    },
    paymentFormat: {
      _id: values.paymentFormatId,
      prepayment: values.prepayment,
      remains: values.remains,
    },
    deadline: values.deadline,
    discount: values.discount,
    designerDiscount: values.designerDiscount,
    orders: getFormattedOrders(),
    companyEntity: values.companyEntity,
  };
};

export const getBodyToUpdateClient = (values) => {
  return {
    name: values.name || "",
    clientType: values.clientType || "",
    legalAddress: values.legalAddress || "",
    BIN: values.BIN || "",
    accountNumber: values.accountNumber || "",
    bankName: values.bankName || "",
    BIC: values.BIC || "",
    fullNameDirector: values.fullNameDirector || "",
    onWhatBasisDirector: values.onWhatBasisDirector || "",
    phone: values.phone || "",
    additionalPhone: values.additionalPhone || "",
    iin: values.iin || "",
    companyName: values.companyName || "",
    companyEntity: values.companyEntity || "",
  };
};

export const getBodyToUpdateLead = (values) => {
  return {
    hasSignature: values.hasSignature,
    address: values.address,
  };
};
